import { CalcRowspanToMerge } from "../../../../../src/demos/calc-rowspan-to-merge";
import * as React from 'react';
export default {
  CalcRowspanToMerge,
  React
};